import { createUseVotesStore } from './store';

const useVotesStore = createUseVotesStore();

export default useVotesStore;
export * from './models';
